import { TranslationValue } from '@prenuvo/halo';

import { ServicesInfo, User } from '@/api';
import { calculateAge, isEmpty } from '@/shared/util';

import { SERVICE_DISPLAY_NAME, SERVICE_INFO_ORDER } from './header.constant';

export const calculateAgeByAccess = (patient: User, hasPIIAccess: boolean): number | undefined => {
  const dob = hasPIIAccess ? patient?.dob : patient?.fake_dob;

  return isEmpty(dob) ? undefined : calculateAge(dob);
};

export const getPatientDisplayName = (
  patient: User,
  hasPIIAccess: boolean,
  unknownNameText: string = 'Unknown Patient Name',
) => {
  if (hasPIIAccess && patient?.lastname && patient?.firstname) {
    return `${patient.lastname}, ${patient.firstname}`;
  }

  if (patient?.fake_lastname && patient?.fake_firstname) {
    return `${patient.fake_lastname}, ${patient.fake_firstname}`;
  }

  return unknownNameText;
};

export const getPatientDob = (
  patient: User,
  hasPIIAccess: boolean,
  translate: (id?: string, values?: TranslationValue) => string | undefined,
) => {
  if (hasPIIAccess && patient?.dob) {
    return translate('FCT.REPORTING.HEADER.PATIENT.DOB', { dob: patient.dob });
  }

  return translate('FCT.REPORTING.HEADER.PATIENT.APPROX_DOB', { dob: patient?.fake_dob });
};

export const getServiceInfoNameList = (servicesInfo: ServicesInfo[]) =>
  servicesInfo
    .slice()
    .sort((a, b) => {
      const aIndex = SERVICE_INFO_ORDER.indexOf(a.code);
      const bIndex = SERVICE_INFO_ORDER.indexOf(b.code);

      return (
        (aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex) -
        (bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex)
      );
    })
    .map((service) => SERVICE_DISPLAY_NAME[service.name] ?? service.name);
